// ** Router imports
import { lazy } from 'react';

// ** Router imports
import { useRoutes, Navigate } from 'react-router-dom';

// ** Layouts
import BlankLayout from '@layouts/BlankLayout';

// ** Utils
import { getUserData, getHomeRouteForLoggedInUser } from '../utility/Utils';

// ** Components
const Error = lazy(() => import('../views/pages/misc/Error'));
const Login = lazy(() => import('../views/pages/authentication/Login'));
const NotAuthorized = lazy(() => import('../views/pages/misc/NotAuthorized'));

const Router = ({ allRoutes }) => {
  const getHomeRoute = () => {
    const user = getUserData();
    if (user) {
      return getHomeRouteForLoggedInUser(user.profile);
    } else {
      return '/login';
    }
  };

  const routes = useRoutes([
    {
      path: '/',
      index: true,
      element: <Navigate replace to={getHomeRoute()} />
    },
    {
      path: '/login',
      element: <BlankLayout />,
      children: [{ path: '/login', element: <Login /> }]
    },
    {
      path: '/auth/not-auth',
      element: <BlankLayout />,
      children: [{ path: '/auth/not-auth', element: <NotAuthorized /> }]
    },
    {
      path: '*',
      element: <BlankLayout />,
      children: [{ path: '*', element: <Error /> }]
    },
    ...allRoutes
  ]);

  return routes;
};

export default Router;
